import Avvir from "avvir";

import apiFailure from "../../events/notifications/failure_notifications/api_failure";
import buildFileName from "../../services/file_name_helpers/build_file_name";
import getFloorId from "../../services/getters/floor_getters/get_floor_id";
import getFloorNumber from "../../services/getters/floor_getters/get_floor_number";
import getProjectIdFromLocation from "../../services/getters/location_metadata/get_project_id_from_location";
import getProjectName from "../../services/getters/project_getters/get_project_name";
import getUser from "../../services/getters/base_getters/get_user";
import triggerFileDownload from "../../services/utilities/general/trigger_file_download";
import runPipeline from "../run_pipeline";
import getProject from "../../services/getters/project_getters/get_project";

const downloadProjectDataTsv = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const projectId = getProjectIdFromLocation(state, {});

    return runPipeline({
      name: "create-project-report",
      firebaseProjectId: projectId
    })(dispatch, getState);
  };
};

export default downloadProjectDataTsv;
